export default "__VITE_ASSET__d7ede717__"